<div class="labels-edit-diff-box">
  <header>
    <label>{{headerText}}</label>
  </header>
  <!-- show labels separated and acto -->
  <div *ngIf="edit; else noEdit" class="labels-edit-container">
    <ng-container *ngIf="fullEditMode; else simpleEditMode">
      <core-label-action 
        [hidden]="matchLabels.length == 0 || labels.length< (minLabels + 1)"
        *ngFor="let tag of matchLabels" 
        [label]="tag"
        (actionClick)="removeLabel($event)">
      </core-label-action>
      <span class="plus" [hidden]="diffLabels.length == 0 || labels.length< (minLabels + 1)" > + </span>
      <core-label-action
        [hidden]="diffLabels.length == 0 || labels.length< (minLabels + 1)"
        *ngFor="let label of diffLabels"
        [label]="label"
        (actionClick)="removeLabel($event)"
      ></core-label-action>
      
      <core-labels-text [hidden]="labels.length > minLabels" [labels]="labels"></core-labels-text>

    </ng-container>

    <ng-template #simpleEditMode>
      <core-labels-text [labels]="matchLabels"></core-labels-text>
      <span class="plus" [hidden]="matchLabels.length == 0 || diffLabels.length == 0 || labels.length< (minLabels + 1)" > + </span>
      <core-label-action
        [hidden]="diffLabels.length == 0 || labels.length< (minLabels + 1)"
        *ngFor="let label of diffLabels"
        [label]="label"
        (actionClick)="removeLabel($event)"
      ></core-label-action>

      <core-labels-text [hidden]="labels.length > minLabels" [labels]="labels"></core-labels-text>
    </ng-template>

    <!-- search box -->
    <app-helpers-labels-search-box 
      [placeholder]="searchPlaceholder" 
      [allowClose]="allowClose"
      [exclude]="labelsToExclude" 
      [add]="access.access_label_add" 
      (choose)="addLabel($event)" 
      (close)="close.emit($event)"
      [(input)]="input">
    </app-helpers-labels-search-box>
  </div>
  <!-- show labels separated -->
   <ng-template #noEdit>
    <div class="labels-edit-container">
      <ng-container *ngIf="availableTagGroups?.length > 0 ; else noGroups">
        <!-- when we have related groups we display option to select other group-->
        <ng-container *ngIf="!showGroups; else showGroupsTemplate">
          <core-labels-text [labels]="matchLabels"></core-labels-text>
          <span class="plus" [hidden]="diffLabels.length == 0"> + </span>
          <core-labels-text [labels]="diffLabels"></core-labels-text>
          <span class="select-group-btn" (click)="toggleGroups()" [hidden]="showGroups || (availableTagGroups.length == 1 && getDiffLabels(availableTagGroups[0]) == 0)">Choose other tags for this new artwork</span>
        </ng-container>
        <!-- while selector of groups is shown, default selected tags are hidden -->
        <ng-template #showGroupsTemplate> 
          <div class="available-artwork-groups" [hidden]="!showGroups">
            <ul>
              <li title="Select this tags group" *ngFor="let group of availableTagGroups" [ngClass]="{'current-group': checkCurrentLabels(group)}"
                  (click)="onSelectGroup(group)">
                  <!-- TODO: remove this span with current     <span *ngIf="checkCurrentLabels(group)"> CURRENT  </span>  -->

                <core-labels-text [labels]="matchLabels"></core-labels-text>
                <span class="plus" [hidden]="getDiffLabels(group) == 0"> + </span>
                <core-labels-text [labels]="getDiffLabels(group)"></core-labels-text>
              </li>
            </ul>
          </div>
        </ng-template>

      </ng-container>
      <ng-template #noGroups>
        <core-labels-text [labels]="matchLabels"></core-labels-text>
        <span class="plus" [hidden]="diffLabels.length == 0"> + </span>
        <core-labels-text [labels]="diffLabels"></core-labels-text>
      </ng-template>
    </div>
   </ng-template>
</div>
